import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../../api';
import '../../styles/AuthModal.css'; // Reusing some styles from AuthModal

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setLoading(true);

        try {
            const response = await authAPI.forgotPassword({ email });
            setMessage(response.message);
            setEmail(''); // Clear email field
        } catch (err) {
            console.error('Erro ao solicitar redefinição de senha:', err);
            setError(err.message || 'Ocorreu um erro ao solicitar a redefinição de senha.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-modal-overlay" style={{ position: 'relative', height: '100vh' }}>
            <div className="auth-modal" style={{ top: '50%', transform: 'translate(-50%, -50%)' }}>
                <div className="auth-header">
                    <h2>Esqueceu sua Senha?</h2>
                </div>

                {message && <div className="auth-success">{message}</div>}
                {error && <div className="auth-error">{error}</div>}

                <form onSubmit={handleSubmit} className="auth-form">
                    <p>Por favor, insira seu endereço de e-mail para receber um link de redefinição de senha.</p>
                    <div className="form-group">
                        <label htmlFor="email">E-mail</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="seu@email.com"
                            disabled={loading}
                            required
                        />
                    </div>

                    <button type="submit" className="auth-submit" disabled={loading}>
                        {loading ? 'Enviando...' : 'Enviar Link de Redefinição'}
                    </button>
                </form>

                <div className="auth-footer">
                    <p>
                        Lembrou da senha? <Link to="/" className="toggle-link">Faça Login</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
